<script>

    import { onMount, beforeUpdate } from "svelte";
    import { Route } from 'svelte-router-spa';
    // import 'bootstrap/dist/css/bootstrap.min.css';

    export let currentRoute
    const params = {}

</script>

<Route {currentRoute} {params} />